<template>
  <div>
    <div class="whitebox right_topbox">
      <div class="right_boxtitle map_title_tab">
        <span :class="{'title':true,'current':currentTab==item.value,'basefont font-20':item.path=='/findProjects','font-16':item.path!='/findProjects'}" v-for="(item) in tabList"
          @click="tabClick(item)" :key="item.value">{{ item.text }} <em class="font-16" v-if="item.value == 1">（ <i class="red-font">* </i>号为必填项 ）</em></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabList: [
        { value: '1', text: '手工建立项目信息', path: '/findProjects' },
        { value: '4', text: '工具一：从目标企业库添加项目方', path: '/focusenterprises' },
        { value: '3', text: '工具二：从关系计算器添加项目方', path: '/enterprisesCityRelation' },
        { value: '2', text: '工具三：从数据库添加项目方', path: '/enterpriseList?type=9' },
        // { value: '5', text: '已录入项目', path: '/projectList' },
      ],
      tabValue: '1',
    }
  },
  props: {
    currentTab: { type: String, default: '1' }
  },
  methods: {
    tabClick(item) {
      this.routerself(item.path);
    }
  }
}
</script>

<style scoped lang="scss">
.right_topbox {
  margin-bottom: 0 !important;
}
.title.basefont{
  font-weight: bold;
}
.current.basefont{
  border-bottom: 2px solid #3A568E;
}
</style>